import React, { memo } from "react";
import { Box, Typography } from "@mui/material";

import KsbItAppBarRight from "./KsbItAppBarRight";
import KsbItAppBarTitle from "./KsbItAppBarTitle";

import "./KsbItAppBarContent.css";
import { useAppContext } from "../../../context/appContext";

function KsbItAppBarContent() {
  const { currentUser, isAuthenticated, isMobile } = useAppContext();

  const isLoggedIn = isAuthenticated && currentUser;

  return (
    <Box
      sx={{
        position: "relative", // ✅ required for absolute title
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        height: "100%",
      }}
    >
      {/* ✅ CENTER (ALWAYS RENDERED) */}
      <KsbItAppBarTitle />
      {/* ✅ LEFT */}
      {isLoggedIn && !isMobile && (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              opacity: 0.8, // ✅ slightly subtle
              whiteSpace: "nowrap", // ✅ prevent wrapping
            }}
          >
            IT Projekte von Lernenden
          </Typography>
        </Box>
      )}
      {/* ✅ RIGHT */}
      {isLoggedIn && (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            // pr: 2,
          }}
          className="scrollable-container"
        >
          <KsbItAppBarRight />
        </Box>
      )}
    </Box>
  );
}

export default memo(KsbItAppBarContent);
